import { render, staticRenderFns } from "./ListBasicInformationsAdditionnelles.vue?vue&type=template&id=506d6d80&scoped=true&"
import script from "./ListBasicInformationsAdditionnelles.vue?vue&type=script&lang=ts&"
export * from "./ListBasicInformationsAdditionnelles.vue?vue&type=script&lang=ts&"
import style0 from "./ListBasicInformationsAdditionnelles.vue?vue&type=style&index=0&id=506d6d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d6d80",
  null
  
)

export default component.exports